module.exports = __webpack_public_path__ + "static/img/frack7.70c7c60e.png";